import { Carousel, Modal } from 'antd'
import { forwardRef, useEffect, useRef, useState } from 'react'

import Flex from '@ui-pc/Flex'
import Icon from '@ui-pc/Icon'
import Rate from '@ui-pc/RateStars'
import Switch from '@ui-pc/Switch'

import { ctx } from '../../../utils'
import Avatar from './Avatar'
import { VideoBox } from './VideoBox'

import type { ViewPhotosDetailProps } from '../types'
import type { CarouselRef } from 'antd/lib/carousel'

export const ViewPhotosDetail = forwardRef((props: ViewPhotosDetailProps) => {
  const { list, photos, refs } = props

  const ref = useRef<CarouselRef>()

  const [show, useShow] = useState(false)

  const [currentIndex, useIndex] = useState(0)

  const onPre = () => {
    ref.current.prev()
  }

  const onNext = () => {
    ref.current.next()
  }

  const ctxRef = ctx.useRef()

  Object.assign(refs.current, {
    useShow(index) {
      useIndex(index)
      useShow(!show)
      setTimeout(() => {
        ref.current.goTo(index)
      }, 10)
    }
  })

  return (
    <Modal
      width={'auto'}
      open={show}
      title={null}
      footer={null}
      centered={true}
      closeIcon={null}
      destroyOnClose
      onCancel={() => useShow(!show)}
      className="view-photos-detail">
      <div className="view-box">
        <Switch either={photos?.length > 1}>
          <>
            <span className="left" onClick={onPre}>
              <Icon customSrc="icon-CaretLeft" />
            </span>
            <span className="right" onClick={onNext}>
              <Icon customSrc="icon-CaretRight" />
            </span>
          </>
        </Switch>
        <span className="closer" onClick={() => useShow(!show)}>
          <Icon customSrc="icon-close" />
        </span>
        <div className="view-box-content-middle Carousel">
          <Carousel
            {...{
              ref: ref,
              dots: false,
              infinite: true,
              speed: 500,
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false
            }}>
            {photos?.map(({ reviewId, src, type }) => {
              const data = list?.find((data) => data.reviewId === reviewId)

              const skuInfo = data.skuInfo

              const [firstOption] = skuInfo.saleOptions || []

              return (
                <div className="content" key={src}>
                  <div className="content-left">
                    <Switch either={type === 2}>
                      <VideoBox>
                        <video autoPlay={false} loop muted src={src} controls />
                      </VideoBox>
                      <Icon className="img-video" src={src} alt="" />
                    </Switch>
                  </div>
                  <div className="content-right">
                    <div className="head">
                      <Flex className="card" warp={false}>
                        <div>
                          <img
                            src={skuInfo.mainImage}
                            alt={skuInfo.productsName}
                          />
                        </div>
                        <Flex className="card-content" direction="column">
                          <span className="title">{skuInfo.productsName}</span>
                          <Switch either={!!firstOption}>
                            <span className="sku">{firstOption}</span>
                          </Switch>
                          <p className="price">
                            <span className="sale-price">
                              {skuInfo.formatFinalPrice}
                            </span>
                            <span className="market-price">
                              {skuInfo.formatMarketPrice}
                            </span>
                          </p>
                        </Flex>
                      </Flex>
                      <button
                        aria-label="@hernest.com"
                        onClick={() => {
                          ctxRef.current.onAddCart({
                            quantity: 1,
                            productsId: skuInfo.productsId,
                            skuId: skuInfo.productsSkuId
                          })
                        }}
                        className="card-addtocart">
                        Add to Cart
                      </button>
                    </div>
                    <div className="content-detail">
                      <div className="detail-head">
                        <Flex warp={false} className="head-left">
                          <Avatar
                            className="avatar"
                            content="username"
                            colorNum={1}
                          />
                          <Flex span="auto" direction="column">
                            <Flex warp={false}>
                              <span className="username">{data.username}</span>
                              <span className="vb">Verified Buyer</span>
                            </Flex>
                            <span className="date">{data.date}</span>
                          </Flex>
                        </Flex>
                        <div className="head-right">
                          <Rate value={data.score} />
                        </div>
                      </div>
                      <div className="detail-body">
                        <div dangerouslySetInnerHTML={{ __html: data.content }}>
                          {/* {data.content} */}
                        </div>
                        <div className="detail-media">
                          {data.medium.map((data) => {
                            return (
                              <div key={data.src}>
                                <Switch either={data.type === 2}>
                                  <VideoBox readonly>
                                    <video
                                      autoPlay={false}
                                      loop
                                      muted
                                      src={data.src}
                                      controls
                                      className={`${
                                        data.src === src &&
                                        'detail-media-current'
                                      }`}
                                    />
                                  </VideoBox>
                                  <img
                                    alt={data.src}
                                    className={`${
                                      data.src === src && 'detail-media-current'
                                    }`}
                                    src={data.src}></img>
                                </Switch>
                              </div>
                            )
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </Carousel>
        </div>
      </div>
    </Modal>
  )
})

export default ViewPhotosDetail
